"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrefsStore = exports.DateFormats = exports.BankHolidayDivisions = void 0;
var Store_1 = require("./Store");
var config_1 = __importDefault(require("config"));
var TableHeading_1 = require("../components/common/table/TableHeading");
var BankHolidayDivisions;
(function (BankHolidayDivisions) {
    BankHolidayDivisions["ENGLAND_AND_WALES"] = "england-and-wales";
    BankHolidayDivisions["NORTHERN_IRELAND"] = "northern-ireland";
    BankHolidayDivisions["SCOTLAND"] = "scotland";
    BankHolidayDivisions["NONE"] = "none";
})(BankHolidayDivisions = exports.BankHolidayDivisions || (exports.BankHolidayDivisions = {}));
var DateFormats;
(function (DateFormats) {
    DateFormats["DD_MM_YYYY"] = "DD/MM/YYYY";
    DateFormats["MM_DD_YYYY"] = "MM/DD/YYYY";
    DateFormats["YYYY_MM_DD"] = "YYYY-MM-DD";
})(DateFormats = exports.DateFormats || (exports.DateFormats = {}));
var storageKeys = config_1.default.storageKeys;
var PrefsStore = /** @class */ (function (_super) {
    __extends(PrefsStore, _super);
    function PrefsStore(data) {
        var _this = _super.call(this, data) || this;
        _this.setData = function (data) {
            if (localStorage.getItem(storageKeys.PREFS) === null)
                localStorage.setItem(storageKeys.PREFS, JSON.stringify(data));
            _this.data = data;
        };
        _this.editData = function (data) {
            if (!_this.checkObject())
                throw Error("Data is not an object, cannot edit data");
            _this.data = __assign(__assign({}, _this.data), data);
            localStorage.setItem(storageKeys.PREFS, JSON.stringify(_this.data));
        };
        return _this;
    }
    return PrefsStore;
}(Store_1.Store));
exports.PrefsStore = PrefsStore;
var initialTable = {
    perPage: 10,
    search: '',
    sort: {
        name: null,
        direction: TableHeading_1.TableDirections.UP
    }
};
var initial = {
    clientsTable: initialTable,
    usersTable: initialTable,
    bankHolidays: null
};
var prefsStore = new PrefsStore(initial);
exports.default = prefsStore;
